// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__ip1Ou","rootCenter":"LoadMoreObserver_rootCenter__34jur","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__1MQ-N"};